import { createContext } from 'react';

const PsContext = createContext<object>({});

export { PsContext };
